// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"679":"dba99f4d","787":"9cb3345b"}[chunkId] + ".chunk.js";
};